    // This file is auto-generated by ./bin/rails stimulus:manifest:update
    // Run that command whenever you add a new controller or create them with
    // ./bin/rails generate stimulus controllerName

    import { app } from "./app"

    import Books__QuickViewController from "./books/quick_view_controller"
    import Books__CardController from "./books/card_controller"
    import NavbarController from "./navbar_controller.js"
    import ChoicesController from "./choices_controller.js"
    import SeriesController from "./series_controller"
    import BusinessController from "./business_controller"

    app.register("business", BusinessController)
    app.register("books--quick-view", Books__QuickViewController)
    app.register("books--card", Books__CardController)
    app.register("navbar", NavbarController)
    app.register("choices", ChoicesController)
    app.register("series", SeriesController)
